import io from 'socket.io-client';
window.io = io;
let token = Ls.get('access_key');

import Echo from "laravel-echo"
window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: SOCKETURL,
  // authEndpoint: "/api/broadcasting/auth",
  transports: ['websocket', 'polling', 'flashsocket'], // Fix CORS error!
  // encrypted: true,
  auth: {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'X-CSRF-TOKEN': 'Bearer ' + token
    },
  }
});


// WEBPACK FOOTER //
// ./src/assets/services/socket.js